import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useSubscription } from './useSubscription';

export function useSubscriptionGuard() {
  const navigate = useNavigate();
  const { user, isAuthenticated, isLoading } = useAuth();
  const { isSubscriptionActive, isLoading: isSubscriptionLoading } = useSubscription();

  useEffect(() => {
    console.log('🔐 [useSubscriptionGuard] Verificando acesso...');
    console.log('📊 [useSubscriptionGuard] isLoading:', isLoading);
    console.log('✅ [useSubscriptionGuard] isAuthenticated:', isAuthenticated);
    console.log('💳 [useSubscriptionGuard] isSubscriptionActive:', isSubscriptionActive);
    console.log('⏳ [useSubscriptionGuard] isSubscriptionLoading:', isSubscriptionLoading);

    if (isLoading || isSubscriptionLoading) {
      console.log('⏳ [useSubscriptionGuard] Aguardando carregamento...');
      return;
    }

    // Se não autenticado, redireciona para plans
    if (!isAuthenticated || !user) {
      console.warn('❌ [useSubscriptionGuard] Usuário não autenticado, redirecionando para /plans');
      navigate('/plans', { replace: true });
      return;
    }

    // Se não tiver assinatura ativa, redireciona para plans
    if (!isSubscriptionActive) {
      console.warn('❌ [useSubscriptionGuard] Sem assinatura ativa, redirecionando para /plans');
      navigate('/plans', { replace: true });
      return;
    }

    console.log('✅ [useSubscriptionGuard] Acesso concedido!');
  }, [isAuthenticated, user, isLoading, isSubscriptionActive, isSubscriptionLoading, navigate]);
}
